import cn from 'clsx'
import { Text, type TextProps } from '@/components/Text/Text'

import css from './Paragraph.module.css'

export function Paragraph({ children, className = '', ...rest }: TextProps) {
    return (
        <Text
            className={cn(css.paragraph, {
                /** Zendesk use a particular naming convertion. (e.g. `wysiwig-text-align-center`, …) */
                [css.center]: className.includes('align-center'),
                [css.left]: className.includes('align-left'),
                [css.right]: className.includes('align-right'),
                [css.justify]: className.includes('align-justify'),
            })}
            size="body-base"
            {...rest}
        >
            {children}
        </Text>
    )
}
